import { useSign, useSignState } from 'context/signview';
import { ListGroup, ListGroupItem, Media } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Circle } from 'components/Sign/SignView';
import { initialLetters } from 'utils';

function Contract({ contract = {} }) {

    const { t } = useTranslation();

    const history = useHistory();

    const handleClick = () => {
        history.replace(`/sign/${contract._id}/${contract.participants[0].jwt}`)
    }

    if (!contract._id) return null;

    return (
        <ListGroupItem
            className="pointer"
            onClick={handleClick}
        >
            <div className="d-flex">
                <div className="flex-fill">
                    <p>
                        <b>{t('contracts.collaborators.contract')}</b>
                    </p>
                    <b>{contract.documentId} - {contract.name} ({t(`contracts.status.${contract.status}`)})</b><br></br>
                    {contract.participants.map((p) => (
                        <Media className="my-2">
                            <Media>
                                <Circle
                                    className="bg-white border mr-2"
                                    text={initialLetters(p.name, p.last_name)}
                                />
                            </Media>
                            <Media className="align-self-center">
                                <span>{p.email} - {t(`contracts.status_v2.${p.status || ''}`)}</span>
                            </Media>
                        </Media>
                    ))}
                </div>
                <div className="align-self-center">
                    <i className="fas fa-chevron-right"></i>
                </div>
            </div>
        </ListGroupItem>
    )
}

export default function RelatedContractsTab() {
    const { t } = useTranslation();
    const { contract: { signViewOptions: { relatedContracts } = {} } = {} } = useSignState()

    return (
        <div className="">
            <h4 className="mb-3">{t('Documentos relacionados')}</h4>
            <p><small>{t('Da click en un documento para visualizar su contenido')}</small></p>

            <b hidden={!relatedContracts.parent?._id}>{t('Documento Principal')}</b>
            <ListGroup className="mt-3">
                <Contract contract={relatedContracts.parent}></Contract>
            </ListGroup>

            <b hidden={!relatedContracts.references.length}>{t('Relacionados')}</b>
            <ListGroup className="mt-3">
                {relatedContracts.references?.map((contract) => (
                    <Contract contract={contract}></Contract>
                ))}
            </ListGroup>
        </div>
    )
}